import api from "@/api";

const state = {
    list: [],
};

const getters = {
    list(state) {
        return state.list;
    },
};

const actions = {
    findByName({ commit }, { query }) {
        if (!query) {
            commit("updateList", { list: [] });
            return;
        }

        return api.get(`/api/teams/get/local/search/${encodeURIComponent(query)}`).then(res => {
            const list = res.data || [];

            commit("updateList", { list });
        });
    },
    reset({ commit }) {
        commit("updateList", { list: [] });
    },
};

const mutations = {
    updateList(state, { list }) {
        state.list = [...list];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
